import { StrictMode, Component } from "react";
import type { ReactNode } from "react";
import ReactDOM from "react-dom/client";

class ErrorBoundary extends Component<{ children: ReactNode }, { error: Error | null }> {
	state = { error: null };
	static getDerivedStateFromError(error: Error) { return { error }; }
	render() {
		const { error } = this.state;
		if (error) {
			return (
				<div style={{ background: "#0d0d10", color: "#fff", minHeight: "100vh", padding: "2rem", fontFamily: "monospace" }}>
					<h2 style={{ color: "#e88" }}>App Error</h2>
					<pre style={{ whiteSpace: "pre-wrap", wordBreak: "break-all", fontSize: "0.75rem", color: "#fcc" }}>
						{(error as Error).message}{"\n\n"}{(error as Error).stack}
					</pre>
					<button
						onClick={() => { this.setState({ error: null }); window.location.reload(); }}
						style={{ marginTop: "1rem", padding: "0.5rem 1rem", background: "#7401cf", color: "#fff", border: "none", borderRadius: "0.5rem" }}
					>
						Reload
					</button>
				</div>
			);
		}
		return this.props.children;
	}
}
import { BrowserRouter, Route, Routes } from "react-router";
import { NuqsAdapter } from "nuqs/adapters/react-router/v7";
import { App } from "./App";
import { Home } from "./components/layout/Home";
import { Login } from "./components/auth/Login";
import { Register } from "./components/auth/Register";
import { Account } from "./components/Account";
import { About } from "./components/About";
import { Accounts } from "./components/layout/Accounts";
import { Chats } from "./components/conversation/Chats";
import { Chat } from "./components/chat/Chat";
import { AppChat } from "./components/AppChat";
import { Apps } from "./components/apps/Apps";
import { SearchMessages } from "./components/SearchMessages";
import { Settings } from "./components/Settings";
import { Admin } from "./components/Admin";
import "./ext";

const root = ReactDOM.createRoot(document.getElementById("root")!);
root.render(
	<StrictMode>
		<ErrorBoundary>
		<NuqsAdapter defaultOptions={{ shallow: false }}>
			<BrowserRouter>
				<Routes>
					<Route element={<App />}>
						<Route index element={<Home />} />
						<Route path="login" element={<Login />} />
						<Route path="register" element={<Register />} />
						<Route path="accounts" element={<Accounts />}>
							<Route path=":accountId" element={<Chats />}>
								<Route index element={<Account />} />
								<Route path="search" element={<SearchMessages />} />
								<Route path="chats">
									<Route index element={<div className="hidden md:flex h-full items-center justify-center text-white/30 text-sm">Select a conversation</div>} />
									<Route path=":chatId" element={<Chat />} />
									<Route path=":chatId/details" element={<Chat />} />
								</Route>
								<Route path="apps" element={<Apps />}>
									<Route index element={<div className="hidden md:flex h-full items-center justify-center text-white/30 text-sm">Select an app</div>} />
									<Route path=":chatId" element={<AppChat />} />
								</Route>
								<Route path="requests">
									<Route index element={<div />} />
									<Route path=":chatId" element={<Chat />} />
								</Route>
							</Route>
						</Route>
						<Route element={<Accounts />}>
							<Route path="about" element={<About />} />
							<Route path="settings" element={<Settings />} />
							<Route path="admin" element={<Admin />} />
						</Route>
					</Route>
				</Routes>
			</BrowserRouter>
		</NuqsAdapter>
		</ErrorBoundary>
	</StrictMode>,
);

if (navigator.serviceWorker) {
	(async () => {
		const reg = await navigator.serviceWorker.ready;
		if (!navigator.serviceWorker.controller) {
			reg.active?.postMessage("clientsClaim");
		}
	})();
}
